// This is a common ts file that all apps should load
// it should load any dependencies which are common across all apps at zip.
import '../log_event';
import { readPageData } from './pageData';

readPageData();

async function lazyLoadScripts() {
  await import(/* webpackChunkName: "ketch" */ '@zr/common/js/ketch');
}

lazyLoadScripts();

export {};
